<!-- <footer class="footer" color="primary" style="padding:0; background:transparent; box-shadow:none; border:none;"> -->
  <footer class="footer" color="primary">
 <div class="content-foot" fxLayout="row" fxLayoutAlign="space-between center">
    <div fxLayout="row" fxLayoutAlign="center center" class="responsive-hide">
      <button mat-icon-button>
        <img class="img-button phone" src="assets/images/social_01.png" alt="phone">
      </button>
    </div>
    <div fxLayout="row" fxLayoutAlign="center center" class="principal">
      <a href="mailto:tuconsulta@seguroscaroni.com" mat-icon-button>
        <img class="img-button second" src="assets/images/social_02.png" alt="mail">
      </a>
    </div>
    <div fxLayout="row" fxLayoutAlign="center center" class="responsive-hide">
      <a href="mailto:tusoporte@seguroscaroni.com" mat-icon-button>
        <img class="img-button mail" src="assets/images/social_03.png" alt="mail">
      </a>
    </div>
  </div>
</footer>
